import axios from "axios";
import { Message } from "element-ui";
import { getErrorRes } from "@/utils/errorRes";
import { getLanguage } from "@/utils/auth";

// create an axios instance
const service = axios.create({
    baseURL: "",
    timeout: 120000 // request timeout
});

axios.defaults.withCredentials = true;
// request interceptor
service.interceptors.request.use(
    config => {
        if (config.type === "json") {
            config.headers["Content-Type"] = "application/json";
        }
        config.headers['Accept-Language'] = getLanguage()
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
);

// 响应拦截
service.interceptors.response.use(
    response => {
        const res = response.data;
        console.log(response);

        // 响应成功
        debugger;
        if (Number(res.statusCode) !== 200 && res.success === false) {
            let errMessage = ''
            errMessage = getErrorRes(res.statusCode)

            Message({
                message: errMessage,
                type: "error",
                duration: 2 * 1000
            });

            return Promise.reject(new Error(res.message || "Error"));
        } else {
            return res;
        }
    },
    error => {
        console.log(error);
        debugger;
        let errMessage = ''
        errMessage = getErrorRes(error.response.status)

        Message({
            message: errMessage,
            type: "error",
            duration: 2 * 1000
        });


        return Promise.reject(error);
    }
);

export default service;